module.exports = __webpack_public_path__ + "img/lifeBlock_7_en.c0e1d283.png";